// extracted by mini-css-extract-plugin
module.exports = {"fullScreenLoading":"styles_fullScreenLoading__2DuY1","loader":"styles_loader__1KN2j","rotate":"styles_rotate__2dT0w"};